import React, { useRef, useState, useEffect } from "react";
import Checklist from "lib/components/Checklist";
import withLanguageContext from "lib/hocs/withLanguageContext";
import withNotifier from "lib/hocs/withNotifier";
import useInViewport from "lib/effects/useInViewport";
import SnackbarAlert from "Components/Fragment/SnackbarAlert";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../../themes/theme";
import styled from "styled-components";

const StyledPortalChecklist = styled.div`
  .MuiPaper-root {
    box-shadow: none !important;
    padding: 0 !important;
    border-radius: 0 !important;
  }
`;

const ChecklistPortal = (props) => {
  let checklistRef = useRef(null);
  let inViewport = useInViewport(checklistRef);
  const checklistStyle = { opacity: inViewport ? 1 : 0 };

  const [openSnackbar, setOpenSnackbar] = useState(false);

  useEffect(() => {
    setOpenSnackbar(props.notification.visible);
  }, [props.notification.visible]);

  const handleClose = () => {
    setOpenSnackbar(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <StyledPortalChecklist ref={checklistRef} style={checklistStyle}>
        <Checklist
          id={props.activityId}
          languageContext={props.languageContext}
          onNotification={props.notification.onNotification}
        >
          {(checklistState, checklistActions) => {
            const {
              onNewItem,
              onAddItem,
              onUpdateItem,
              onSelectItem,
              onCopy,
              onCopyChecklist,
              onDeleteItems,
              onReset,
              onValidation,
              checklistItems_actions,
            } = checklistActions;
            const {
              checklist,
              activitiesToCopyFrom,
              activeItem,
              selectedItems,
              languageContext,
              displayItem,
              displayCopy,
              displayReminder,
            } = checklistState;

            const notificationType = props.notification.type || "info";

            return (
              <React.Fragment>
                {!checklistState.displayItem && (
                  <Checklist.Header
                    languageContext={languageContext}
                    onAdd={onNewItem}
                    onCopy={onCopy}
                    onDelete={onDeleteItems}
                    showCopy={checklistState.activitiesToCopyFrom.length > 0}
                    showDelete={false}
                  />
                )}
                <br />
                {!displayItem && (
                  <Checklist.TablePortal
                    languageContext={languageContext}
                    actions={checklistActions}
                    list={checklist.tasks}
                    activitiesToCopyFrom={checklistState.activitiesToCopyFrom}
                  />
                )}
                {displayItem && (
                  <Checklist.Item
                    languageContext={languageContext}
                    item={activeItem}
                    onSave={
                      activeItem.checklistItemID ? onUpdateItem : onAddItem
                    }
                    onCancel={onReset}
                    actions={checklistActions}
                    editable
                    onValidation={onValidation}
                  />
                )}
                {displayCopy && (
                  <Checklist.Copy
                    languageContext={languageContext}
                    onCancel={onReset}
                    onCopyChecklist={onCopyChecklist}
                    activitiesToCopyFrom={activitiesToCopyFrom}
                  />
                )}
                {displayReminder && (
                  <Checklist.Reminder
                    languageContext={languageContext}
                    onCancel={onReset}
                  />
                )}
                {props.notification && (
                  <SnackbarAlert
                    open={openSnackbar}
                    message={props.notification.message}
                    severity={notificationType}
                    onClose={handleClose}
                  />
                )}
              </React.Fragment>
            );
          }}
        </Checklist>
      </StyledPortalChecklist>
    </ThemeProvider>
  );
};

export default withLanguageContext(withNotifier(ChecklistPortal), "Checklists");
